import axios from 'axios';

const url = process.env.REACT_APP_API_URL + '/v1/auth';

export const login = (data) => axios.post(`${url}/login/`, data);
export const register = (data) => axios.post(`${url}/register/`, data);
export const logout = () => axios.get(`${url}/logout/`);
export const check = () => axios.get(`${url}/check/`);